"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withTheme = _interopRequireDefault(require("./withTheme"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = (0, _withTheme.default)(() => /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
    id: "Group-2",
    transform: "translate(3.000000, 3.000000)",
    stroke: "currentColor",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      id: "disc",
      transform: "translate(1.125000, 1.125000)",
      strokeWidth: "2",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M8.4375,16.875 C13.0974026,16.875 16.875,13.0974026 16.875,8.4375 C16.875,3.77759742 13.0974026,-5.44616435e-15 8.4375,-5.44616435e-15 C3.77759742,-5.44616435e-15 -3.55271368e-15,3.77759742 -3.55271368e-15,8.4375",
        id: "Oval",
        transform: "translate(8.437500, 8.437500) rotate(90.000000) translate(-8.437500, -8.437500) "
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
        id: "circle3740",
        cx: "8.26875",
        cy: "8.26875",
        r: "2.53125"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      stroke: "currentColor",
      strokeWidth: "3.99065828",
      strokeMiterlimit: "4",
      strokeDasharray: "none",
      id: "arrow-right",
      transform: "matrix(0.30083517,0.30161207,-0.30161207,0.30083517,3.3242017,-0.87918408)",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M 0,7 H 14",
        id: "Shape",
        strokeWidth: "3.99065828",
        strokeMiterlimit: "4",
        strokeDasharray: "none"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polyline", {
        id: "polyline3779",
        points: "7 0 14 7 7 14",
        strokeWidth: "3.99065828",
        strokeMiterlimit: "4",
        strokeDasharray: "none"
      })]
    })]
  })
}));